import { createApiClient } from '@perplexicon/api-client';

/**
 * The single `ApiClient` instance the whole web app shares (docs/APP_PLAN.md
 * §5.2). `baseUrl` defaults to `/api`, which — combined with the Vite dev
 * proxy (`vite.config.ts`) and Caddy's `/api/*` route in production — keeps
 * every request same-origin so the API's CSRF defense passes without any
 * extra configuration here.
 */
export const apiClient = createApiClient();
